/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import injectSheet, { createUseStyles } from 'react-jss'
import { connect, useDispatch, useSelector } from 'react-redux'
import {
  branch, compose, renderComponent, lifecycle, withState,
} from 'recompose'
import { useOutletContext } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableHead from '@mui/material/TableHead'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import StyledLink from '../../../../StyledLink'
import Button from '../../../../Button'
import Loader from '../../../../Loader'
import TimeFrameFilter from '../../../../Filters/TimeFrameFilter'
import PagingControl from '../../../../PagingControl'
import AffiliationsPopover from './AffiliationsPopover'
import { formatDateTime, formatDateWithoutTimezone, formatPhoneNumber } from '../../../../../formatting'
import {
  createOfferUserSearch,
  updateOfferUserSearch,
  searchOfferUsers,
} from '../../../../../redux/actions'
import {
  createFilteredOfferUsersSelector,
  selectOfferUsersSearch,
} from '../../../../../redux/selectors'
import { downloadListingSpecialOffersUserSubscriptionReportLink } from '../../../../../setup/routeConstants'

export const DEFAULT_SEARCH = (listing) => ({
  id: 'offer-users',
  filter: {
    timeFrame: {
      type: 'any', from: null, to: null, expanded: false,
    },
    listing,
  },
  paging: {
    pageSize: 25,
  },
})

const SEARCH_ID = 'offer-users'

export function ReportsTab() {
  const { verificationListing: listing } = useOutletContext()
  const dispatch = useDispatch()

  const [loaded, setLoaded] = useState(false)

  const getSearchFilter = selectOfferUsersSearch(SEARCH_ID)
  const filteredOfferUsers = createFilteredOfferUsersSelector(SEARCH_ID)
  const search = useSelector(getSearchFilter)
  const offerUsers = useSelector(filteredOfferUsers)

  const createSearch = () => dispatch(createOfferUserSearch(DEFAULT_SEARCH(listing)))
  const onPageSizeChange = (searchObj, pageSize) => {
    setLoaded(false)
    return dispatch(
      updateOfferUserSearch({ ...searchObj, paging: { ...searchObj.paging, pageSize } }),
    ).then((s) => dispatch(searchOfferUsers(SEARCH_ID)).then((x) => setLoaded(true)))
  }
  const loadOfferUsers = () => {
    setLoaded(false)
    return dispatch(searchOfferUsers(SEARCH_ID)).then((x) => setLoaded(true))
  }
  const onUpdateSearchFilter = (searchObj) => {
    setLoaded(false)
    return dispatch(updateOfferUserSearch(searchObj)).then((s) => dispatch(searchOfferUsers(SEARCH_ID)).then((x) => setLoaded(true)))
  }

  useEffect(() => {
    if (listing?.id) {
      createSearch().then(() => loadOfferUsers())
    }
  }, [listing?.id])

  if (!listing) return null
  if (!loaded) return <Loader />
  return (
    <div style={{ minWidth: 'min-content' }}>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h2" style={{ margin: '0px', padding: '10px 0px', fontSize: '20px' }}>Offer opt-ins</Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ margin: '0px 0px 20px', textAlign: 'right' }}>
            <StyledLink
              to={downloadListingSpecialOffersUserSubscriptionReportLink(search)}
              contents={(
                <Button
                  style={{ }}
                  label="Download"
                  variant="contained"
                  color="primary"
                  smallButton
                  fullWidth={false}
                />
     )}
              newWindow
            />
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}>
          <TimeFrameFilter search={search} onUpdate={onUpdateSearchFilter} anchor="timeFilterAnchor" />
          <div id="timeFilterAnchor" />
        </Grid>
        <Grid item xs={8}>&nbsp;</Grid>
      </Grid>
      <PagingControl
        pageSize={search.paging.pageSize}
        total={search.total}
        onChange={(pageSize) => onPageSizeChange(search, pageSize)}
      />

      {search.total > 0
    && (
    <Table>
      <TableHead style={{ backgroundColor: '#f1f1f1' }}>
        <TableRow>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            First Name
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Last Name
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Email
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Date of Birth
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Zip
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Gender
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Phone
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Affiliations
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Offer ID
          </TableCell>
          <TableCell style={{
            fontSize: '14px', color: '#222', fontWeight: '600', whiteSpace: 'nowrap',
          }}
          >
            Timestamp
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {
        (offerUsers.map((u, i) => (
          <TableRow key={i}>
            <TableCell style={{ position: 'relative' }}>{ u.firstName }</TableCell>
            <TableCell style={{ position: 'relative' }}>{ u.lastName }</TableCell>
            <TableCell style={{ position: 'relative' }}>{ u.email }</TableCell>
            <TableCell style={{ position: 'relative' }}>{ u.dateOfBirth && formatDateWithoutTimezone(u.dateOfBirth) }</TableCell>
            <TableCell style={{ position: 'relative' }}>{ u.zipCode }</TableCell>
            <TableCell style={{ position: 'relative' }}>{ u.gender }</TableCell>
            <TableCell style={{ position: 'relative', whiteSpace: 'nowrap' }}>{ formatPhoneNumber(u.phoneNumber) }</TableCell>
            <TableCell style={{ position: 'relative' }}><AffiliationsPopover occupationPaths={u.occupationPaths} /></TableCell>
            <TableCell style={{ position: 'relative' }}>{ u.specialOfferId }</TableCell>
            <TableCell style={{ position: 'relative', whiteSpace: 'nowrap' }}>{ formatDateTime(u.createdOnUtc) }</TableCell>
          </TableRow>
        )))
      }
      </TableBody>
    </Table>
    )}
      {search.total === 0 && (
        <Typography variant="body1" style={{ padding: '24px 0px', color: '#6b6b6b' }}>
          No offer opt-ins for the selected time frame.
        </Typography>
      )}
      <PagingControl
        pageSize={search.paging.pageSize}
        total={search.total}
        isBottom
        onChange={(pageSize) => onPageSizeChange(search, pageSize)}
      />
    </div>
  )
}

export default ReportsTab
